









import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CardContainer extends Vue {
  @Prop({ type: String, required: false }) readonly title!: string;
  @Prop({ type: String, required: false }) readonly extraClass!: string;
  @Prop({ type: Boolean, required: false, default: true }) readonly withShadow!: boolean;
  @Prop() readonly containerStyle!: any;

}
